// Contentful CMS
export const space_id = "i659s1n3x8kw";

export const access_token = "kQW4tXwNijOnb__7yST09gbBTUQ-v2Ex-Zdz_AFc8R4";

// Formspree
export const formspree_url = "xvoljyqa";

// MailChimp
export const mailchimp_url =
  "https://app.us14.list-manage.com/subscribe/post?u=1cb86952863aedfa91505c97c&amp;id=5011c2a698&amp;f_id=004291e0f0";
